/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceRef,
  BalanceRefOptional,
  BalanceRefMetaI,
  BalanceRefTrackedI,
} from "./balance-ref";
import { BalanceRefTracked, BalanceRefMeta } from "./balance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentSourceFull,
  PaymentSourceFullOptional,
  PaymentSourceFullMetaI,
  PaymentSourceFullTrackedI,
} from "./payment-source-full";
import {
  PaymentSourceFullTracked,
  PaymentSourceFullMeta,
} from "./payment-source-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";

/**
 *
 * @export
 * @interface PaymentSourceDTO
 */
export interface PaymentSourceDTOOptional extends PaymentSourceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PaymentSourceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentSourceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentSourceDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentSourceDTO
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  stripePaymentSource?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof PaymentSourceDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {BalanceRef}
   * @memberof PaymentSourceDTO
   */
  balanceSource?: BalanceRefOptional;
}

export interface PaymentSourceDTO
  extends PaymentSourceDTOOptional, PaymentSourceFull {
  /**
   *
   * @type {boolean}
   * @memberof PaymentSourceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentSourceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentSourceDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  endActive?: Date;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentSourceDTO
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  stripePaymentSource?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof PaymentSourceDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {BalanceRef}
   * @memberof PaymentSourceDTO
   */
  balanceSource?: BalanceRef;
}

export interface PaymentSourceDTOTrackedI extends PaymentSourceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PaymentSourceDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PaymentSourceDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PaymentSourceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {PaymentType}
   * @memberof PaymentSourceDTO
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PaymentSourceDTO
   */
  stripePaymentSource?: string;
  stripePaymentSourceIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PaymentSourceDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {BalanceRef}
   * @memberof PaymentSourceDTO
   */
  balanceSource?: BalanceRefTrackedI;
  balanceSourceIsSet: boolean;
}

transformDatesMap.set("PaymentSourceDTO", function (model: PaymentSourceDTO) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
  const transformDatespersonId = transformDatesMap.get("PersonRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
  const transformDatesbalanceSource = transformDatesMap.get("BalanceRef");
  if (transformDatesbalanceSource && model.balanceSource) {
    transformDatesbalanceSource(model.balanceSource);
  }
});

export type PaymentSourceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  stripePaymentSource: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  balanceSource: PropertyMeta<BalanceRefMetaI>;
}>;

export var PaymentSourceDTOMeta: PaymentSourceDTOMetaI =
  {} as PaymentSourceDTOMetaI;
PaymentSourceDTOMeta = typeMeta("PaymentSourceDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  paymentType: propertyMeta(
    "paymentType",
    false,
    false,
    false,
    PaymentTypeMeta,
  ),
  stripePaymentSource: propertyMeta(
    "stripePaymentSource",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  balanceSource: propertyMeta(
    "balanceSource",
    false,
    false,
    false,
    BalanceRefMeta,
  ),
});

const metaI = PaymentSourceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([PaymentSourceFullMeta]);
  metaI.isDeleted.inheritedFrom = PaymentSourceFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = PaymentSourceFullMeta.isNew;
  metaI.assignId.inheritedFrom = PaymentSourceFullMeta.assignId;
  metaI.startActive.inheritedFrom = PaymentSourceFullMeta.startActive;
  metaI.endActive.inheritedFrom = PaymentSourceFullMeta.endActive;
  metaI.paymentType.inheritedFrom = PaymentSourceFullMeta.paymentType;
  metaI.stripePaymentSource.inheritedFrom =
    PaymentSourceFullMeta.stripePaymentSource;
  metaI.personId.inheritedFrom = PaymentSourceFullMeta.personId;
  metaI.balanceSource.inheritedFrom = PaymentSourceFullMeta.balanceSource;
});

export class PaymentSourceDTOTracked
  extends PaymentSourceFullTracked
  implements PaymentSourceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  stripePaymentSource__I?: string = undefined;
  stripePaymentSourceIsSet: boolean = false;
  set stripePaymentSource(v: undefined | string) {
    if (v !== undefined) {
      this.stripePaymentSource__I = v;
      this.stripePaymentSourceIsSet = true;
    } else {
      this.stripePaymentSource__I = v || undefined;
      this.stripePaymentSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripePaymentSource() {
    return this.stripePaymentSource__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  balanceSource__I?: BalanceRefTracked = undefined;
  balanceSourceIsSet: boolean = false;
  set balanceSource(v: undefined | BalanceRefTracked) {
    if (v !== undefined) {
      this.balanceSource__I = v;
      this.balanceSourceIsSet = true;
    } else {
      this.balanceSource__I = v || undefined;
      this.balanceSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceSource() {
    return this.balanceSource__I;
  }
  constructor(config?: PaymentSourceDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.balanceSource?.setIds();
  }
  assignFrom(
    config: PaymentSourceDTOOptional,
    options?: AssignOptions,
  ): PaymentSourceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.stripePaymentSource &&
      this.stripePaymentSourceApplyFilter(optionsRequired.filter)
    ) {
      this.stripePaymentSource = config.stripePaymentSource;
      if (optionsRequired.unassign) this.stripePaymentSourceIsSet = false;
      else this.stripePaymentSourceIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.balanceSource &&
      this.balanceSourceApplyFilter(optionsRequired.filter)
    ) {
      this.balanceSource = new BalanceRefTracked(config.balanceSource, options);
      if (optionsRequired.unassign) this.balanceSourceIsSet = false;
      else this.balanceSourceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PaymentSourceDTOTrackedI {
    const cloned = {} as PaymentSourceDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.stripePaymentSourceIsSetDeep() &&
      this.stripePaymentSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripePaymentSourceIsSet = true;
      cloned.stripePaymentSource = this.stripePaymentSource;
    } else {
      //cloned.stripePaymentSourceIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.balanceSourceIsSetDeep() &&
      this.balanceSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceSourceIsSet = true;
      cloned.balanceSource = this.balanceSource?.removeUnset(filter);
    } else {
      //cloned.balanceSourceIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PaymentSourceDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.stripePaymentSourceApplyFilter(filter))
      this.stripePaymentSourceIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.balanceSourceApplyFilter(filter)) this.balanceSourceIsSet = false;
    this.balanceSource?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.isDeleted,
      PaymentSourceDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.isNew,
      PaymentSourceDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.assignId,
      PaymentSourceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.startActive,
      PaymentSourceDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.endActive,
      PaymentSourceDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.paymentType,
      PaymentSourceDTOMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  stripePaymentSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.stripePaymentSource,
      PaymentSourceDTOMeta,
      this.stripePaymentSource,
      this,
    );
  }
  stripePaymentSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripePaymentSourceIsSet &&
      this.stripePaymentSourceApplyFilter(filter)
    )
      return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.personId,
      PaymentSourceDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  balanceSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PaymentSourceDTOMeta.balanceSource,
      PaymentSourceDTOMeta,
      this.balanceSource,
      this,
    );
  }
  balanceSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceSourceIsSet && this.balanceSourceApplyFilter(filter))
      return true;
    return this.balanceSource?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.stripePaymentSourceIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.balanceSourceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
